// extracted by mini-css-extract-plugin
export default {"textContainer":"TruncatedText__textContainer--KD49A","toggleButton":"TruncatedText__toggleButton--Tosh_","show-more-less":"TruncatedText__show-more-less--ben56"};